<div class="advanced-search-container">
  <div class="advanced-search-header" *ngIf="!showResultsOnMobile || !isMobileView">
    <h2 class="header-title">Advanced search</h2>
    <button class="close-btn" (click)="onClose()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>


  <div class="advanced-search-content" *ngIf="!showResultsOnMobile || !isMobileView">
    <!-- Search Query -->
    <div class="search-input-field">
      <div class="input-container">
        <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <div class="chat-tags" *ngIf="selectedChats.length > 0">
          <span class="chat-tag" *ngFor="let chat of selectedChats">
            {{ chat.name }}
            <button class="remove-tag" (click)="removeChatTag(chat)">×</button>
          </span>
        </div>
        <input type="text" placeholder="Search messages..." [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchQueryChange($event)">
        <button class="clear-search-btn" *ngIf="searchQuery" (click)="clearSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      @if(showMentions){
      <button class="close-mentions-absolute" (click)="closeMentions()" title="Close Suggestions">×</button>
      }
      @if(showMentions){
      <div class="mentions-dropdown">
        <div class="mention-item" *ngFor="let mention of filteredMentions" (click)="selectMention(mention)">
          <div class="mention-avatar-wrap">
            @if (mention.image) {
            <img [src]="mention.image" class="mention-avatar" (error)="mention.image = ''">
            } @else {
            <div class="mention-avatar-placeholder">
              {{ (mention.name || 'U').substring(0, 1).toUpperCase() }}
            </div>
            }
          </div>
          <span class="mention-name">{{ mention.name }}</span>
        </div>
        <div class="mention-item blank-mention" *ngIf="filteredMentions.length === 0">
          No matches found
        </div>
      </div>
      }
    </div>

    <div class="filter-section">
      <p class="section-label">SEARCH IN</p>
      <div class="search-in-grid">
        <button [class.active]="searchIn === 'users'" (click)="onSearchInSelect('users')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          Single
        </button>
        <button [class.active]="searchIn === 'groups'" (click)="onSearchInSelect('groups')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          Groups
        </button>
      </div>
    </div>

    <!-- Type Selection -->
    <div class="filter-section">
      <p class="section-label">TYPE</p>
      <div class="type-grid">
        <button [class.active]="selectedType === 'photo'" (click)="onTypeSelect('photo')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
          Photo
        </button>
        <button [class.active]="selectedType === 'video'" (click)="onTypeSelect('video')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="23 7 16 12 23 17 23 7"></polygon>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
          </svg>
          Video
        </button>
        <button [class.active]="selectedType === 'doc'" (click)="onTypeSelect('doc')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          Docs
        </button>
        <button [class.active]="selectedType === 'audio'" (click)="onTypeSelect('audio')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18V5l12-2v13"></path>
            <circle cx="6" cy="18" r="3"></circle>
            <circle cx="18" cy="16" r="3"></circle>
          </svg>
          Audio
        </button>
        <button [class.active]="selectedType === 'link'" (click)="onTypeSelect('link')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
          </svg>
          Link
        </button>
        <button [class.active]="selectedType === 'other'" (click)="onTypeSelect('other')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
          </svg>
          Other
        </button>
      </div>
    </div>

    <!-- Subtype Selection (Conditional) -->
    <div class="filter-section" *ngIf="selectedType && subtypesMap[selectedType]">
      <p class="section-label">SUBTYPE</p>
      <div class="subtype-tags">
        <button *ngFor="let subtype of subtypesMap[selectedType]" [class.active]="selectedSubtype === subtype"
          (click)="onSubtypeSelect(subtype)">
          {{ subtypeDisplayMap[subtype] || subtype }}
        </button>
      </div>
    </div>

    <!-- Direction Selection -->
    <div class="filter-section">
      <p class="section-label">DIRECTION</p>
      <div class="direction-grid">
        <button [class.active]="direction === 'all'" (click)="onDirectionSelect('all')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
          </svg>
          All
        </button>
        <button [class.active]="direction === 'incoming'" (click)="onDirectionSelect('incoming')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="17 7 12 12 7 7"></polyline>
            <polyline points="17 12 12 17 7 12"></polyline>
          </svg>
          Inbound
        </button>
        <button [class.active]="direction === 'outgoing'" (click)="onDirectionSelect('outgoing')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="17 17 12 12 7 17"></polyline>
            <polyline points="17 12 12 7 7 12"></polyline>
          </svg>
          Outbound
        </button>
      </div>
    </div>

    <!-- Date Range -->
    <div class="filter-section">
      <p class="section-label">DATE RANGE</p>
      <div class="date-flex">
        <input type="date" [(ngModel)]="startDate" #startInput (click)="startInput.showPicker?.()"
          (change)="onDateChange()" class="date-input">
        <span class="date-arrow">→</span>
        <input type="date" [(ngModel)]="endDate" #endInput (click)="endInput.showPicker?.()" (change)="onDateChange()"
          class="date-input">
      </div>
    </div>

    <!-- Saved Drafts Section -->
    <div class="drafts-section" *ngIf="savedDrafts.length > 0 || isLoadingDrafts">
      <div class="section-header-flex">
        <p class="section-label">SAVED DRAFTS</p>
        <span class="preset-count" *ngIf="savedDrafts.length > 0">{{ savedDrafts.length }}</span>
      </div>
      <div class="draft-items">
        <div class="draft-item" *ngFor="let draft of savedDrafts">
          <div class="draft-details" (click)="applyDraft(draft)">
            <span class="draft-name">{{ getDraftDisplayName(draft) }}</span>
            <span class="draft-meta">
              {{ getDraftFilterSummary(draft) }}
            </span>
          </div>
          <div class="draft-actions">
            <button class="delete-draft-btn" (click)="deleteDraft(draft._id || draft.id)" title="Delete Preset">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="load-more-presets" *ngIf="hasMoreDrafts && savedDrafts.length >= draftLimit">
          <button (click)="loadMoreDrafts()" [disabled]="isLoadingDrafts" class="load-more-btn">
            {{ isLoadingDrafts ? 'Loading...' : 'Load more presets' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Results List -->
  <div class="mobile-results-view" *ngIf="isMobileView && showResultsOnMobile">
    <div class="mobile-results-header">
      <button class="mobile-back-to-filters" (click)="backToFilters.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <span class="mobile-results-title">Results</span>
      <span class="mobile-matches-count">{{ results.length }} matches</span>
    </div>

    <!-- Search Query (Sticky at top of results) -->
    <div class="search-input-field sticky-top">
      <div class="input-container">
        <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        <div class="chat-tags" *ngIf="selectedChats.length > 0">
          <span class="chat-tag" *ngFor="let chat of selectedChats">
            {{ chat.name }}
            <button class="remove-tag" (click)="removeChatTag(chat)">×</button>
          </span>
        </div>
        <input type="text" placeholder="Search messages..." [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchQueryChange($event)">
        <button class="clear-search-btn" *ngIf="searchQuery" (click)="clearSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="mentions-dropdown" *ngIf="showMentions">
        <button class="close-mentions-absolute" (click)="closeMentions()" title="Close Suggestions">×</button>
        <div class="mention-item" *ngFor="let mention of filteredMentions" (click)="selectMention(mention)">
          <div class="mention-avatar-wrap">
            @if (mention.image) {
            <img [src]="mention.image" class="mention-avatar" (error)="mention.image = ''">
            } @else {
            <div class="mention-avatar-placeholder">
              {{ (mention.name || 'U').substring(0, 1).toUpperCase() }}
            </div>
            }
          </div>
          <div class="mention-info">
            <span class="mention-name">{{ mention.name }}</span>
            <span class="mention-type" *ngIf="mention.type === 'group'">(Group)</span>
          </div>
        </div>
        <div class="mention-item blank-mention" *ngIf="filteredMentions.length === 0">
          No matches found
        </div>
      </div>
    </div>

    <!-- Results Gallery -->
    <div class="mobile-gallery-content" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
      (scrolled)="searchNextPage()" [scrollWindow]="false">
      @if (results && results.length > 0) {
      @if (selectedType === 'photo') {
      <div class="gallery-grid">
        @for (chat of results; track (chat.id || chat._id || $index)) {
        <div class="gallery-item" (click)="onChatClick(chat)">
          <img [src]="chat.meta?.compressedImgUrl || chat.url || chat.meta?.fileUrl || chat.fileUrl || chat.message"
            class="gallery-image" alt="Search result" (error)="$any($event.target).style.display='none'">
          <div class="gallery-info">
            <span class="gallery-name"
              [innerHTML]="(chat.displayName || chat.name) | highlightText: searchQuery"></span>
            <span class="gallery-date">{{ chat.lastMessageTimeAgo || chat.date }}</span>
          </div>
        </div>
        }
      </div>
      } @else if (selectedType === 'video') {
      <div class="gallery-grid">
        @for (chat of results; track (chat.id || chat._id || $index)) {
        <div class="gallery-item video-gallery-item" (click)="onChatClick(chat)">
          <div class="video-thumb-bg">
            @if (chat.meta?.thumbnailUrl) {
            <img [src]="chat.meta.thumbnailUrl" class="video-thumb" alt="Video thumbnail" (error)="chat.meta.thumbnailUrl = ''">
            } @else {
            <video [src]="chat.meta?.fileUrl || chat.fileUrl || chat.message" class="video-thumb" muted
              playsinline webkit-playsinline disablePictureInPicture preload="metadata" (error)="$any($event.target).style.display='none'"></video>
            }
          </div>
          <div class="video-play-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="white">
              <circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.4)" />
              <polygon points="10 8 16 12 10 16 10 8" fill="white" />
            </svg>
          </div>
          <div class="gallery-info">
            <span class="gallery-name"
              [innerHTML]="(chat.displayName || chat.name) | highlightText: searchQuery"></span>
            <span class="gallery-date">{{ chat.lastMessageTimeAgo || chat.date }}</span>
          </div>
        </div>
        }
      </div>
      } @else if (selectedType === 'doc') {
      <div class="doc-list">
        @for (chat of results; track (chat.id || chat._id || $index)) {
        <div class="doc-item" (click)="onChatClick(chat)">
          <div class="doc-icon-wrap" [style.background]="getDocColor(chat)">
            <span class="doc-type-badge">{{ getDocLabel(chat) }}</span>
          </div>
          <div class="doc-details">
            <span class="doc-filename" [innerHTML]="getCleanFileName(chat) | highlightText: searchQuery"></span>
            <span class="doc-meta" [innerHTML]="(chat.displayName || chat.name) | highlightText: searchQuery"></span>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="results-list">
        @for (chat of results; track (chat.id || chat._id || $index)) {
        <div class="result-item" (click)="onChatClick(chat)">
          <div class="result-avatar">
            @if (chat.profileImg || chat.profileImage) {
            <img [src]="chat.profileImg || chat.profileImage" class="avatar-img"
              (error)="handleProfileImageError($event, chat.chatType === 'group')">
            } @else {
            <div class="avatar-placeholder">
              {{ (chat.displayName || chat.name || 'U').substring(0, 1).toUpperCase() }}
            </div>
            }
          </div>
          <div class="result-info">
            <div class="result-top">
              <span class="result-name"
                [innerHTML]="(chat.displayName || chat.name) | highlightText: searchQuery"></span>
              <span class="result-date">{{ chat.lastMessageTimeAgo || chat.date }}</span>
            </div>
            <div class="result-message">
              @if (isLink(chat)) {
              <div class="link-row-info">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="link-inline-icon">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
                @if (chat.meta?.title || chat.meta?.description) {
                <div class="link-row-text">
                  @if (chat.meta?.title) {
                  <span class="link-row-title" [innerHTML]="chat.meta.title | highlightText: searchQuery"></span>
                  }
                  @if (chat.meta?.description) {
                  <span class="link-row-desc" [innerHTML]="chat.meta.description | highlightText: searchQuery"></span>
                  }
                  <span class="link-row-url">{{ getLinkDomain(chat.message) }}</span>
                </div>
                } @else {
                <span class="link-direct-url" [innerHTML]="chat.message | highlightText: searchQuery"></span>
                }
              </div>
              } @else {
              <span [innerHTML]="chat.message | highlightText: searchQuery"></span>
              }
            </div>
          </div>
        </div>
        }
      </div>
      }

      @if (isSearching) {
      <div class="results-loader">
        <span class="spinner"></span>
        <span>Loading...</span>
      </div>
      }
      } @else if (isSearching) {
      <div class="initial-loader">
        <span class="spinner"></span>
      </div>
      } @else {
      <div class="empty-results">
        <p>No matches found</p>
      </div>
      }
    </div>
  </div>

  <!-- Action Buttons (Fixed at bottom) -->
  <div class="action-footer" *ngIf="!showResultsOnMobile || !isMobileView">
    <button class="search-btn btn-primary" (click)="onSearch()" [disabled]="isSearching"
      *ngIf="isMobileView">Search</button>
    <button class="save-draft-btn btn-secondary" (click)="saveAsDraft()">Save Draft</button>
    <button class="reset-btn btn-danger" (click)="onReset()">Reset</button>
  </div>
</div>